<script lang="ts" setup>
defineProps({
  disbled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <a-button
    :disabled="disbled"
    class="btn-send flex-center !absolute bottom-5 right-5 !flex !h-[32px] w-[110px] !p-0"
    type="primary"
    ><span>发送</span>
    <a-tooltip v-if="!disbled" :title="'按下回车发送'">
      <span class="absolute left-0 right-0 h-full w-full"></span>
    </a-tooltip>
  </a-button>
</template>
<style scoped>
.btn-send:disabled {
  @apply border-transparent !bg-[#BFBFBF] text-white;
}
</style>
